import React from "react";

export interface BeaconMapProps {
  beaconId: string;
  initialPolyline: [number, number][];
  status: number;
  athleteName: string;
  sourceApp: string;
}

const BeaconMap = ({
  beaconId,
  initialPolyline,
  status,
  athleteName,
  sourceApp,
}: BeaconMapProps) => {
  return (
    <div
      id="beacon-map-mre"
      style={{ width: "100%", height: "100%" }}
      data-beacon-id={beaconId}
      data-status={status}
      data-athlete-name={athleteName}
      data-source-app={sourceApp}
      data-polyline-points={initialPolyline.length}
    />
  );
};

export default BeaconMap;
